import { render, staticRenderFns } from "./PainScaleDialog.vue?vue&type=template&id=2d7483e7&scoped=true"
import script from "./PainScaleDialog.vue?vue&type=script&lang=js"
export * from "./PainScaleDialog.vue?vue&type=script&lang=js"
import style0 from "./PainScaleDialog.vue?vue&type=style&index=0&id=2d7483e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7483e7",
  null
  
)

export default component.exports